var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef, createRef, useCallback } from 'react';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import { SearchInput, SearchInputWrapper, SearchInputIcon, SearchResultWrapper, SearchResultInner, ModalContentWrapper, EmptyMessage, LoadingMessageTextWrapper, LoadingMessageText, LoadingIcon, } from './styles';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import ResultCard from './ResultCard';
import { loadSearchedApps, setSearchString, updateSelectedItem, } from '../../../store/globalSearch/actions';
import { selectSearchedApps, selectSelectedItemKey, selectAppsLoading, selectSearchString, } from '../../../store/globalSearch/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from '../../../utils';
var GlobalSearchModal = function (props) {
    var isVisible = props.isVisible, setVisible = props.setVisible;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var searchResults = useSelector(selectSearchedApps);
    var selectedItemKey = useSelector(selectSelectedItemKey);
    var appsLoading = useSelector(selectAppsLoading);
    var searchString = useSelector(selectSearchString);
    var _a = useState(-1), selectedArrayIndex = _a[0], setSelectedArrayIndex = _a[1];
    var _b = useState(false), mouseMoveActive = _b[0], setMouseMoveActive = _b[1];
    var scrollRefs = useRef([]);
    scrollRefs.current = searchResults.map(function (_, i) { var _a; return (_a = scrollRefs.current[i]) !== null && _a !== void 0 ? _a : createRef(); });
    var scrollSmoothHandler = function (index) {
        scrollRefs.current[index].current.scrollIntoView();
    };
    var handleSetSearchString = debounce(function (value) {
        dispatch(loadSearchedApps(value));
        dispatch(setSearchString(value));
        dispatch(updateSelectedItem(''));
        setSelectedArrayIndex(-1);
    }, 300);
    var updateSelectedItemOnMouseMove = function (appId) {
        debounce(dispatch(updateSelectedItem("app_".concat(appId))), 500);
        setSelectedArrayIndex(searchResults.findIndex(function (obj) { return obj.id === appId; }));
    };
    var handleKeyDown = useCallback(function (e) {
        var _a, _b;
        setMouseMoveActive(false);
        var updateSelectedItemOnKeyDown = function (arrayIndex) {
            debounce(dispatch(updateSelectedItem("app_".concat(searchResults[arrayIndex].id))), 500);
            setSelectedArrayIndex(arrayIndex);
            scrollSmoothHandler(arrayIndex);
        };
        var isEnterKeyClicked = e.keyCode === 13;
        var isDownKeyClicked = e.keyCode === 40;
        var isUpKeyClicked = e.keyCode === 38;
        var nextArrayIndex = selectedArrayIndex + 1 === searchResults.length
            ? selectedArrayIndex
            : selectedArrayIndex + 1;
        isDownKeyClicked && updateSelectedItemOnKeyDown(nextArrayIndex);
        var prevArrayIndex = selectedArrayIndex === 0 || selectedArrayIndex === -1
            ? 0
            : selectedArrayIndex - 1;
        isUpKeyClicked && updateSelectedItemOnKeyDown(prevArrayIndex);
        isEnterKeyClicked &&
            selectedArrayIndex !== -1 &&
            navigate("/organizations/".concat((_a = searchResults[selectedArrayIndex]) === null || _a === void 0 ? void 0 : _a.org_id, "/apps/").concat((_b = searchResults[selectedArrayIndex]) === null || _b === void 0 ? void 0 : _b.id, "/overview"));
    }, [dispatch, navigate, searchResults, selectedArrayIndex]);
    useEffect(function () {
        var setMouseMove = function () {
            setMouseMoveActive(true);
        };
        window.addEventListener('mousemove', setMouseMove);
        window.addEventListener('keydown', handleKeyDown);
        return function () {
            window.removeEventListener('mousemove', setMouseMove);
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown, setMouseMoveActive]);
    return (_jsx(Modal, __assign({ ariaHideApp: false, headerTitle: "Global Search", open: isVisible, onClose: function () {
            setVisible(false);
        }, isOpen: isVisible, onRequestClose: function () {
            setVisible(false);
        }, style: {
            content: {
                height: '500px',
                width: '560px',
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                boxShadow: '2px 2px 16px rgba(0, 0, 0, 0.2)',
                borderRadius: '8px',
                padding: '0',
                border: '0',
            },
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.25)',
            },
        }, contentLabel: "Global Search" }, { children: _jsxs(ModalContentWrapper, { children: [_jsxs(SearchInputWrapper, { children: [_jsx(SearchInputIcon, { icon: faSearch }), _jsx(SearchInput, { defaultValue: searchString, autoFocus: true, onChange: function (event) { return handleSetSearchString(event.target.value); } })] }), _jsx(SearchResultWrapper, { children: searchString.length === 0 ? (_jsx(EmptyMessage, { children: _jsx(LoadingMessageText, { children: "Please type in search bar" }) })) : appsLoading ? (_jsx(EmptyMessage, { children: _jsxs(LoadingMessageTextWrapper, { children: [_jsx(LoadingIcon, { icon: faSpinner, spin: true }), _jsx(LoadingMessageText, { children: "Loading app list, please wait..." })] }) })) : searchResults.length === 0 ? (_jsx(EmptyMessage, { children: _jsxs(LoadingMessageText, { children: ["No results for \"", searchString, "\""] }) })) : (_jsx(SearchResultInner, { children: searchResults.map(function (appDetails, index) {
                            return (_jsx(ResultCard, { selected: selectedItemKey === "app_".concat(appDetails.id), appDetails: appDetails, searchString: searchString, updateSelectedItemOnMouseMove: updateSelectedItemOnMouseMove, resultCardRef: scrollRefs.current[index], mouseMoveActive: mouseMoveActive, setAppData: props.setAppData, setUpdateModalOpen: props.setUpdateModalOpen }, "app_".concat(appDetails.id)));
                        }) })) })] }) })));
};
export default GlobalSearchModal;
